import { WrapperCaSyncErrors } from "./style";
import { Typography, Button, message, Space } from "antd";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { TableCaSyncErrors } from "./ui/table/TableCaSyncErrors";
import { jobSyncCaPaymentsService } from "../../shared/services";
import { useState } from "react";

const { Title } = Typography;

export default function CaSyncErrors() {
  const [isLoadingFromExternal, setIsLoadingFromExternal] = useState(false);
  const [isLoadingToExternal, setIsLoadingToExternal] = useState(false);

  const handleSyncFromExternal = async () => {
    setIsLoadingFromExternal(true);
    try {
      await jobSyncCaPaymentsService.find({});
      message.success('Sincronización desde externo iniciada exitosamente!');
    } catch (error: any) {
      console.error('[CaSyncErrors:FromExternal] Error starting sync job:', error);
      message.error(error?.message || 'Error al iniciar sincronización desde externo');
    } finally {
      setIsLoadingFromExternal(false);
    }
  };

  const handleSyncToExternal = async () => {
    setIsLoadingToExternal(true);
    try {
      await jobSyncCaPaymentsService.create({});
      message.success('Sincronización hacia externo iniciada exitosamente!');
    } catch (error: any) {
      console.error('[CaSyncErrors:ToExternal] Error starting sync job:', error);
      message.error(error?.message || 'Error al iniciar sincronización hacia externo');
    } finally {
      setIsLoadingToExternal(false);
    }
  };

  return (
    <WrapperCaSyncErrors>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <Title style={{ textAlign: "left", fontSize: 25, margin: 0 }}>Registro de Errores de Sincronización</Title>
        <Space>
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            onClick={handleSyncFromExternal}
            loading={isLoadingFromExternal}
            disabled={isLoadingFromExternal || isLoadingToExternal}
          >
            {isLoadingFromExternal ? 'Sincronizando Desde Externo...' : 'Sincronizar Desde Externo'}
          </Button>
          <Button
            type="primary"
            icon={<UploadOutlined />}
            onClick={handleSyncToExternal}
            loading={isLoadingToExternal}
            disabled={isLoadingFromExternal || isLoadingToExternal}
          >
            {isLoadingToExternal ? 'Sincronizando Hacia Externo...' : 'Sincronizar Hacia Externo'}
          </Button>
        </Space>
      </div>
      <TableCaSyncErrors />
    </WrapperCaSyncErrors>
  );
}

